import { normalizeShortCode } from "../shared/short-code";
import QRCode from "qrcode";
import type { Registration } from "./types";

export function qrPayload(registration: Registration): string {
  const shortCode = normalizeShortCode(registration.id);
  if (shortCode) return shortCode;
  if (registration.signedQr) return registration.signedQr;
  return JSON.stringify({
    type: "nutrified-petexpo26-registration",
    version: 1,
    id: registration.id,
    name: registration.name,
    createdAt: registration.createdAt,
  });
}

export async function renderQr(canvas: HTMLCanvasElement, registration: Registration) {
  await QRCode.toCanvas(canvas, qrPayload(registration), {
    width: 320,
    margin: 2,
    errorCorrectionLevel: "M",
    color: {
      dark: "#0a2928",
      light: "#ffffff",
    },
  });
}
